import { render, staticRenderFns } from "./genbyidea2.vue?vue&type=template&id=77cda8d5&scoped=true"
import script from "./genbyidea2.vue?vue&type=script&lang=js"
export * from "./genbyidea2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cda8d5",
  null
  
)

export default component.exports